import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

const Header = (props) => {
  return (
    <header id="header">
      <h1 id="logo">
        <ScrollLink to="home" spy={true} smooth={true} offset={0}
          duration={500}>
          <img src="images/miranda-logo-header.png" alt="Soares de Miranda e André" />
        </ScrollLink>
      </h1>
      <nav id="nav">
        <ul>
          <li>
            <ScrollLink to="home" spy={true} smooth={true} offset={0}
              duration={500}>
              Home
            </ScrollLink>
          </li>
          <li>
            <ScrollLink to="about" spy={true} smooth={true} offset={0}
              duration={500}>
              Sobre nós
            </ScrollLink>
          </li>
          <li>
            <ScrollLink to="portfolio" spy={true} smooth={true} offset={0}
              duration={500}>
              Portfólio
            </ScrollLink>
          </li>
          <li>
            <ScrollLink to="services" spy={true} smooth={true} offset={0}
              duration={500}>
              Serviços
            </ScrollLink>
          </li>
          <li>
            <ScrollLink to="contact" spy={true} smooth={true} offset={0}
              duration={500}>
              Contactos
            </ScrollLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js